// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__G-53D","tab":"Tabs_tab__-z_AT","tabActive":"Tabs_tabActive__Ynywv"};